import _ from "lodash";
/** external */
import React, { Fragment, useCallback, memo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
/** internal */
import {
  WORKSHEET_MODES,
  MODE_TEACHER_VIEW,
  MODE_TEACHER_CREATE,
} from "Worksheet/modules/WorksheetConstants";
import {
  deleteQuestionOrganizationResource,
  duplicateQuestionInWorksheet,
} from "Worksheet/modules/WorksheetModules";
import Question from "Worksheet/components/Question";
/** relative */
import classes from "./SectionDetails.scss";

const SectionDetails = memo(props => {
  const {
    sectionId,
    questions,
    mode,
    deleteQuestionOrganizationResource,
    duplicateQuestionInWorksheet,
    setQuestionRef,
    isFromLibrary,
    portalType,
    showWorksheetAssistant,
    parentId,
    isStudentWorkbookForceViewMode,
    assignmentId,
    studentAssignmentId,
    isStudentRevamp,
    isLockScreenEnabled,
  } = props;

  const deleteSectionChildResource = useCallback(
    childResourceId => {
      deleteQuestionOrganizationResource({
        id: childResourceId,
        parentId: sectionId,
      });
    },
    [deleteQuestionOrganizationResource, sectionId]
  );

  const duplicateSectionChildResource = useCallback(
    async ({
      questionId,
      questionResourceId,
      parentResourceId,
      isSubQuestion,
    }) => {
      return await duplicateQuestionInWorksheet({
        questionId: questionId,
        questionResourceId: questionResourceId,
        parentResourceId: parentResourceId ? parentResourceId : sectionId,
        isSubQuestion: isSubQuestion,
      });
    },
    [parentId, sectionId]
  );

  const containerClasses = classNames(classes.container, {
    [classes.viewContainer]: mode != MODE_TEACHER_CREATE && !isFromLibrary,
    [classes.importFromLibraryContainer]: isFromLibrary,
  });

  const questionClasses = classNames({
    [classes.createModeQuestionPadding]: mode == MODE_TEACHER_CREATE,
    [classes.questionCardRevamp]: isStudentRevamp && !isFromLibrary,
  });

  return (
    <div className={containerClasses}>
      {_.map(questions, question => {
        const questionResourceId = _.get(question, "resourceId");

        return (
          <Fragment key={questionResourceId}>
            <div className={questionClasses}>
              <Question
                key={questionResourceId}
                mode={mode}
                onDeleteClick={deleteSectionChildResource}
                setQuestionRef={setQuestionRef}
                isFromLibrary={isFromLibrary}
                portalType={portalType}
                duplicateSectionChildResource={duplicateSectionChildResource}
                {...question}
                showWorksheetAssistant={showWorksheetAssistant}
                isStudentWorkbookForceViewMode={isStudentWorkbookForceViewMode}
                assignmentId={assignmentId}
                studentAssignmentId={studentAssignmentId}
                isLockScreenEnabled={isLockScreenEnabled}
              />
            </div>
          </Fragment>
        );
      })}
    </div>
  );
});

const mapActionCreators = {
  deleteQuestionOrganizationResource,
  duplicateQuestionInWorksheet,
};

const mapStateToProps = (state, ownProps) => {
  const parentId = _.get(state, "worksheet.parentEntity.id");
  return { parentId };
};
SectionDetails.propTypes = {
  sectionId: PropTypes.string,
  questions: PropTypes.arrayOf(PropTypes.object),
  mode: PropTypes.oneOf(WORKSHEET_MODES),
  setQuestionRef: PropTypes.func,
  isLastSection: PropTypes.bool,
  isFromLibrary: PropTypes.bool,
  isStudentWorkbookForceViewMode: PropTypes.bool,
  assignmentId: PropTypes.string,
  isStudentRevamp: PropTypes.bool,
};

SectionDetails.defaultProps = {
  questions: [],
  mode: MODE_TEACHER_VIEW,
  setQuestionRef: _.noop,
  isLastSection: false,
  isStudentRevamp: false,
};
SectionDetails.displayName = "SectionDetails";

export default connect(mapStateToProps, mapActionCreators)(SectionDetails);
